import { cookies } from "./modules/cookies";
import { lazyBg } from "./modules/lazy-bg";
import { lazyLoad } from "./modules/lazy-load";
import { navigation } from "./modules/navigation";
import { validation } from "./modules/validation";

const choiceChange = () => {
  const input = document.querySelector("[data-choice]");
  const our = document.getElementById("delivery-our");
  const own = document.getElementById("delivery-own");

  input.addEventListener("change", ( e ) => {
    if(e.target.value.includes("własny")) {
      own.style.display = "block";
      our.style.display = "none";
    } else {
      our.style.display = "block";
      own.style.display = "none";
    }
  });
};

function onDocumentReady() {
  cookies.init();
  lazyBg.init();
  lazyLoad.init();
  navigation.init();
  validation.init();
  choiceChange();
}
if (document.readyState !== "loading") {
  onDocumentReady(); // Or setTimeout(onReady, 0); if you want it consistently async
} else {
  document.addEventListener("DOMContentLoaded", onDocumentReady);
}
